import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * Five bars share one `@keyframes` rule; **stagger** comes from `animation-delay: calc(var(--i) * 0.1s)`
 * on each span (`--i` set inline). Align to bottom with `align-items: flex-end` so height animates “up”.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'spinner-dots',
  category: 'loading',
  title: 'Spinner (bars)',
  description: 'Five bars with staggered animation-delay.',
  tags: [T.loading, T.animation, T.css],
  html: `<h2>Bar pulse</h2>

<!-- Each span sets --i so CSS can stagger animation-delay -->
<div class="bars" role="status" aria-label="Loading"><span style="--i:0"></span><span style="--i:1"></span><span style="--i:2"></span><span style="--i:3"></span><span style="--i:4"></span></div>`,
  css: `${shell}

h2 {
  color: var(--nogrok-preview-primary);
  margin: 0 0 1rem;
}

.bars {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  height: 36px;
}

.bars span {
  width: 6px;
  height: 8px;
  background: var(--nogrok-preview-primary);
  border-radius: 3px;
  animation: bu 0.9s ease-in-out infinite;
  animation-delay: calc(var(--i) * 0.1s);
}

@keyframes bu {
  0%,
  100% {
    height: 8px;
    opacity: 0.35;
  }
  50% {
    height: 32px;
    opacity: 1;
  }
}`,
  js: '',
}

export default preset
